import { Select } from "antd";
import { getIn, useFormikContext } from "formik";

const SelectInput = (props) => {
    const { 
        name, 
        prefix = null, 
        placeholder, 
        label, 
        options = [], 
        size = 'middle', 
        disabled = false, 
        handleChange = () => {}, 
        className = "", 
        labelClassName = '',
        isRequired = false ,
        allowClear = false,
    } = props;
    
    const { values, setFieldValue, handleBlur, errors, touched } = useFormikContext();
    const error = getIn(errors, name);
    const isTouched = getIn(touched, name);
    const value = getIn(values, name);
    
    return (
        <div className="relative">
            {label && <label className={`mb-1 block ${labelClassName}`} htmlFor={name}>{label} {isRequired && <span className='text-red-600'>*</span>}</label>}
            <Select
                id={name}
                name={name}
                placeholder={placeholder}
                value={value}
                optionFilterProp="label"
                size={size}
                virtual
                filterOption={(input, option) =>
                    option.label?.toLowerCase().includes(input?.toLowerCase())
                }
                showSearch
                onChange={(value) => {
                    setFieldValue(name, value);
                    handleChange(value);
                }}
                className={`w-full ${className}`}
                onBlur={handleBlur}
                options={options}
                status={error && isTouched ? "error" : ""}
                prefix={prefix ? prefix : null}
                disabled={disabled}
                listItemHeight={40}
                optionLabelProp="label"
                allowClear={allowClear}
                style={{width:'100%'}}
                optionRender={(option) => (
                    <div className="whitespace-normal break-words">
                        {option.label}
                    </div>
                )}
            />
            {error && isTouched && (
                <span className={`input-error`}>{error}</span>
            )}
        </div>
    );
};

export default SelectInput;